
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Http } from '@angular/http';
import { AuthenticationService } from '../_shared/services/authentication.service';
import { ProfileType } from './steel-profile';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ProfileTypeService {
  private url = `${environment.apiUrl}/profile-type/`;

  constructor(private http: Http,
    private authService: AuthenticationService) {
  }

  /*TODO handle errors*/

  getAll(): Observable<ProfileType[]> {
    return this.http.get(this.url, this.authService.getAuthOptions()).map((res) => res.json());
  }

  get(id: number): Observable<ProfileType> {
    return this.http.get(`${this.url}${id}/`, this.authService.getAuthOptions()).map((res) => {
      return res.json();
    });
  }

  update(profile_type: ProfileType): Observable<ProfileType> {
    const url = `${this.url}${profile_type.id}/`;
    return this.http.put(url, JSON.stringify(profile_type), this.authService.getAuthOptions()).map((res) => res.json());
  }

  delete(profile_type: ProfileType): Observable<ProfileType> {
    const url = `${this.url}${profile_type.id}/`;
    return this.http.delete(url, this.authService.getAuthOptions()).map((res) => res.json());
  }

  create(profile_type: ProfileType): Observable<ProfileType> {
    return this.http.post(this.url, JSON.stringify(profile_type), this.authService.getAuthOptions()).map((res) => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/steel-profile/profile-type.service.ts